import {action} from "mobx";
import transferService from "../services/transferService";
import appStore from "./appStore";

class transferStore {
    @action transfers = async () => {
        try {
            const resultOfRequest = await transferService.transfers();
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return [];
            }
            return resultOfRequest.data;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
    };
    @action transfersRegions = async () => {
        try {
            const resultOfRequest = await transferService.transferRegions();
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return [];
            }
            return resultOfRequest.data;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
    };
    @action transferCenters = async params => {
        try {
            const resultOfRequest = await transferService.transferCenters(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return [];
            }
            return resultOfRequest.data;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
    };
    @action transferGroups = async params => {
        try {
            const resultOfRequest = await transferService.transferGroups(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return [];
            }
            return resultOfRequest.data;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
    };
    @action activeTransfers = async params => {
        try {
            const resultOfRequest = await transferService.activeTransfers(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return [];
            }
            return resultOfRequest.data;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
    };
    @action createTransferReference = async params => {
        try {
            const resultOfRequest = await transferService.createTransferReference(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return {};
            }
            return resultOfRequest.data;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return {};
        }
    };
    @action createRotation = async params => {
        try {
            const resultOfRequest = await transferService.createRotation(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return [];
            }
            return resultOfRequest.data;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
    };
    @action createTransferWithReference = async params => {
        try {
            const resultOfRequest = await transferService.createTransferWithReference(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return [];
            }
            return resultOfRequest.data;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
    };
    @action getTransferReference = async params => {
        try {
            const resultOfRequest = await transferService.getTransferReference(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return [];
            }
            return resultOfRequest.data;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
    };
    @action returnTranferReferenceEdit = async params => {
        try {
            const resultOfRequest = await transferService.returnTranferReferenceEdit(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return true;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };
    @action updateTransferGroup = async params => {
        try {
            const resultOfRequest = await transferService.updateTransferGroup(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return [];
            }
            return resultOfRequest.data;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
    };
    @action moveShipment = async params => {
        try {
            const resultOfRequest = await transferService.moveShipment(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return true;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action acceptableMoveTransferPackets = async params => {
        try {
            const resultOfRequest = await transferService.acceptableMoveTransferPackets(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return [];
            }
            return resultOfRequest.data;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
    };

    @action shipmentTransferGroupList = async params => {
        try {
            const resultOfRequest = await transferService.shipmentTransferGroupList(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return [];
            }
            return resultOfRequest.data;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
    };
    @action transferGroupShipmentList = async params => {
        try {
            const resultOfRequest = await transferService.transferGroupShipmentList(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return [];
            }
            return resultOfRequest.data;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
    };
    @action transferShipmentActivities = async params => {
        try {
            const resultOfRequest = await transferService.transferShipmentActivities(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return [];
            }
            return resultOfRequest.data;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
    };
    @action updateTransferGroupCutOff = async params => {
        try {
            const resultOfRequest = await transferService.updateTransferGroupCutOff(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return true;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };
    @action undeliveredShipments = async params => {
        try {
            const resultOfRequest = await transferService.undeliveredShipments(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return [];
            }
            return resultOfRequest.data;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
    };
    @action transferCenterList = async params => {
        try {
            const resultOfRequest = await transferService.transferCenterList(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return [];
            }
            return resultOfRequest.data;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return [];
        }
    };
    @action scheduleNextDay = async params => {
        try {
            const resultOfRequest = await transferService.scheduleNextDay(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return true;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };
    @action updateTransferCenterStatus = async params => {
        try {
            const resultOfRequest = await transferService.updateTransferCenterStatus(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return true;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };
    @action sendBackToCompany = async params => {
        try {
            const resultOfRequest = await transferService.sendBackToCompany(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return true;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };
    @action createTransferCenter = async params => {
        try {
            const resultOfRequest = await transferService.createTransferCenter(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return true;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };
    @action acceptableMoveTransfer = async params => {
        try {
            const resultOfRequest = await transferService.acceptableMoveTransfer(params);
            return resultOfRequest.data;
        } catch (error) {
            console.log(error);
            return [];
        }
    };
    @action moveShipmentToTransfer = async params => {
        try {
            const resultOfRequest = await transferService.moveShipmentToTransfer(params);
            if (resultOfRequest.data.success !== true) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return resultOfRequest.data;
            }
            appStore.openSuccessModal({content: resultOfRequest.data.message});
            return resultOfRequest.data;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: error.response.data.message});
            return resultOfRequest.data;
        }
    };
    @action moveShipmentToNewTransfer = async params => {
        try {
            const resultOfRequest = await transferService.moveShipmentToNewTransfer(params);
            if (resultOfRequest.data.success !== true) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return resultOfRequest.data;
            }
            appStore.openSuccessModal({content: resultOfRequest.data.message});
            return resultOfRequest.data;
        } catch (error) {
            console.log(error);
            appStore.openErrorModal({content: error.response.data.message});
            return resultOfRequest.data;
        }
    };
}

export default new transferStore();
